import {useRouter} from 'next/router';
import {requestContext} from '../../../../common/requestContext';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useContentHomeOverviewQuery} from '../../../../wrapper/contentWrapper';

import {TAB_TYPE_QUERY_KEY} from '../constant';
import {
  ContentHomeTabType,
  MobileContentHomeTabType,
  PcContentHomeTabType,
} from '../type';
import {getShouldShowPreviewTab} from '../util/getShouldShowPreviewTab';

// 콘텐츠홈의 기본 tab 을 선택하기 위한 hook 이며 render 와 getLayout 에서 사용하기 위해 hook 으로 정의합니다
export function useSelectContentHomeTabType(seriesId: number) {
  const {isMobile} = requestContext.requestInfo.display;
  const {preview, pageContinue} =
    useContentHomeOverviewQuery({seriesId}, ONLY_DATA_CONFIG).data
      ?.contentHomeOverview?.content?.serviceProperty || {};

  const showPreviewTab = getShouldShowPreviewTab({
    isMobile,
    preview,
    pageContinue,
  });

  const router = useRouter();

  const tabTypeQuery = router.query[TAB_TYPE_QUERY_KEY] as ContentHomeTabType;

  const defaultTab = isMobile
    ? ContentHomeTabType.product
    : ContentHomeTabType.overview;

  // 모웹 콘텐츠 홈의 경우 디폴트는 '회차' 탭이며, PC웹 콘텐츠 홈의 경우 디폴트는 '홈' 탭입니다.
  const tabType = isMobile
    ? tabTypeQuery in MobileContentHomeTabType
      ? tabTypeQuery
      : defaultTab
    : tabTypeQuery in PcContentHomeTabType
      ? tabTypeQuery
      : defaultTab;

  // preview 탭을 보여줄 수 있는 상태에서 query로 명확하게 탭이 선택되지 않았다면 preview 탭으로 보내줍니다.
  return showPreviewTab
    ? !tabTypeQuery || tabTypeQuery === ContentHomeTabType.preview
      ? ContentHomeTabType.preview
      : tabType
    : tabType === ContentHomeTabType.preview
      ? defaultTab
      : tabType;
}
